'use client'
import { useEffect, useRef } from 'react'

interface ScrollDetectorProps {
    onScroll: (isScrolled: boolean) => void
}

const ScrollDetector: React.FC<ScrollDetectorProps> = ({ onScroll }) => {
    const onScrollRef = useRef(onScroll)
    onScrollRef.current = onScroll

    useEffect(() => {
        let ticking = false
        const handleScroll = () => {
            if (ticking) return
            ticking = true
            requestAnimationFrame(() => {
                onScrollRef.current(window.scrollY > 0)
                ticking = false
            })
        }
        window.addEventListener('scroll', handleScroll, { passive: true })
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return null
}

export default ScrollDetector
